import { Pipe, PipeTransform } from '@angular/core';
import {IStringAnyMap} from "lib-boox";

@Pipe({
  name: 'menuApplication',
  standalone: true
})
export class MenuApplicationPipe implements PipeTransform {

  transform(applications: IStringAnyMap[], menu : string|null = null): IStringAnyMap[] {
    return applications.filter((app: IStringAnyMap) => !!app['menu'] && (!menu || app['menu'] === menu));
  }
}
